import { render } from "./platform.vue?vue&type=template&id=73a982fe&scoped=true"
import script from "./platform.vue?vue&type=script&lang=js"
export * from "./platform.vue?vue&type=script&lang=js"

import "./platform.vue?vue&type=style&index=0&id=73a982fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a982fe"]])

export default __exports__